export const parseCurrency = (value) => {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'number') return Number.isFinite(value) ? Number(value.toFixed(2)) : '';

    let normalized = String(value)
        .replace(/[^\d,.-]/g, '')
        .trim();

    if (!normalized) return '';

    if (normalized.includes(',')) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else {
        const parts = normalized.split('.');
        if (parts.length === 2 && parts[1].length === 3) {
            normalized = parts.join('');
        }
        if (parts.length > 2) {
            normalized = `${parts.slice(0, -1).join('')}.${parts.at(-1)}`;
        }
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? Number(parsed.toFixed(2)) : '';
};

export const toCurrencyMaskValue = (value) => {
    const parsed = parseCurrency(value);
    if (parsed === '') return '';
    return parsed.toFixed(2).replace('.', ',');
};

export const formatCurrency = (value, fallback = 'R$ 0,00') => {
    const parsed = parseCurrency(value);
    if (parsed === '') return fallback;

    return parsed.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
